"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusTrap = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var react_1 = __importDefault(require("react"));
var focusable_1 = require("../functions/focusable");
var useMergedRefs_1 = require("../hooks/useMergedRefs");
/**
 * Trap focus within child container.
 * Used for modals and dialogs.
 */
var FocusTrap = function (props) {
    var children = props.children;
    var childRef = react_1.default.useRef();
    var getFirstLastFocusables = function () {
        var elements = (0, focusable_1.getTabbableElements)(childRef.current);
        var firstElement = elements[0];
        var lastElement = elements[(elements.length || 1) - 1];
        return [firstElement, lastElement];
    };
    var onFirstFocus = function (event) {
        var _a = getFirstLastFocusables(), firstElement = _a[0], lastElement = _a[1];
        if (event.relatedTarget === firstElement) {
            lastElement === null || lastElement === void 0 ? void 0 : lastElement.focus();
        }
        else {
            firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
        }
    };
    var onLastFocus = function (event) {
        var _a = getFirstLastFocusables(), firstElement = _a[0], lastElement = _a[1];
        if (event.relatedTarget === lastElement) {
            firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
        }
        else {
            lastElement === null || lastElement === void 0 ? void 0 : lastElement.focus();
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { tabIndex: 0, onFocus: onFirstFocus, "aria-hidden": true }),
        react_1.default.cloneElement(children, {
            ref: (0, useMergedRefs_1.mergeRefs)(children.ref, childRef),
        }),
        react_1.default.createElement("div", { tabIndex: 0, onFocus: onLastFocus, "aria-hidden": true })));
};
exports.FocusTrap = FocusTrap;
exports.default = exports.FocusTrap;
